import {Component, OnInit,ViewChild, ElementRef, HostListener} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {MessagesService} from '../../services/messages.service';
import {FormArray, FormControl, FormGroup, Validators} from '@angular/forms';
import {LookupService} from '../../services/lookup.service';
import {CustomerFormService} from '../../services/customer-form.service';
import {ClrLoadingState} from '@clr/angular';
import {forkJoin, Observable} from 'rxjs';
import {ReCaptcha2Component, NgxCaptchaModule} from 'ngx-captcha';
import {
  BUSINESS_TYPES,
  FILE_SIZE_LIMIT,
  FILE_FORMATS_ALLOWED,
  FILE_SIZE_ERROR,
  FILE_FORMAT_ERROR,
  FILE_LIMIT_ERROR
} from '../../shared/constants.util';
import {REGEX} from '../../shared/regex.util';

@Component({
  selector: 'app-customer',
  templateUrl: './customer.component.html',
  styleUrls: ['./customer.component.css'],
  providers: [NgxCaptchaModule]
})
export class CustomerComponent implements OnInit {
  @ViewChild('captchaElem') captchaElem: ReCaptcha2Component;

  constructor(private route: ActivatedRoute,
    private messagesService: MessagesService,
    private lookupService: LookupService,
    private customerService: CustomerFormService,
    private router: Router) {
this.messagesService.sendBGMessage('no');
this.currentDivision = 'atd';
this.currentCountry = 'US';
this.mySQLOrgId = 82;
this.phoneCountryCode = '1';
this.businessTypes = BUSINESS_TYPES;
this.messagesService.sendLogoMessage(this.currentDivision);
this.initializeStates(this.currentCountry);
this.initializeBusinessStructures(this.currentDivision === 'atd' ? 0 : 0);
this.customerStatus();

}

  ngOnInit() {

    this.initializeExistingCustomer();
    this.phonetypes = ['Telephone','Mobile'];
    this.initializeValidators();
  }

  customerApplicationForm: FormGroup;
  PROSPECT_ADDRESS: FormArray;
  PROSPECT_REFERENCE: FormArray;
  currentDivision = 'atd';
  countiesApplicant: Array<any>;
  customerNumber: number;
  countiesRefOne: Array<any>;
  countiesRefTwo: Array<any>;
  countiesPG: Array<any>;
  states: Array<any>;
  businessStructures: Array<any>;
  businessTypes: Array<string>;
  validateBtnState: ClrLoadingState = ClrLoadingState.DEFAULT;
  mySQLOrgId: number;
  phoneCountryCode: string;
  currentCountry: string;
  toggleCreditApplication: string;
  togglePersonalGuaranty : string;
  toggleBusinessNameChange: string;
  showTC = false;
  showError = false;
  errorMessage: string;
  guarantorDocB64: any;
  mjfDocB64: any;
  guarantorDocLabel: string;
  mjfDocLabel: string;
  guarantorDoc: any;
  mjfDoc: any;
  docError = false;
  guarantorDocObject: object = {};
  mjfDocObject: object = {};
  mjFileErrorMessage: string;
  pgErrorMessage: string;
  stateTaxFilesLabels: Array<string> = [];
  stateTaxFilesError: string;
  stateTaxFiles: Array<any> = [];
  stateTaxFilesObjects: Array<any> = [];
  phonetypes = [];
  phonetype: string;
  currentDate: string = new Date().toLocaleDateString();
  customer = this.customer;
  st=true;
  UpdatedDbaName:string;
  UpdatedApplicantName: string;
  creditValue: any;
  addressState: boolean = false;
  addressCounty: boolean = false;
  typeOfBusiness: boolean = false;
  phoneLineType: boolean = false;
  phoneLineTypeTwo: boolean = false;
  public readonly siteKey = '6LdHn5sUAAAAAECrwsqUGbWrO2_y1NheVlXXVjvv';
  public captchaIsLoaded = false;
  public captchaSuccess = false;
  public captchaIsExpired = false;
  public captchaResponse?: string;

  customerStatus(){
    let check = this.route.queryParams.subscribe(params => {
      this.customer = params['customer'];
    });
}

setToTwoDecimals(val: any){
  this.creditValue = parseFloat(val).toFixed(2);
  return this.creditValue;
}

valueIsSelect(type:any, value: any){
  switch(type + " "+ value){
    case ('addressState Select'):
      this.customerApplicationForm.controls['PROSPECT_ADDRESS']['controls'][0].get('STATE').setErrors({ 'Invalid': true });
      this.addressState = true;
    break;
    case ('addressCounty Select'):
      this.customerApplicationForm.controls['PROSPECT_ADDRESS']['controls'][0].get('COUNTY').setErrors({ 'Invalid': true });
      this.addressCounty = true;
    break;
    case ('phoneLineType Select'):
      this.customerApplicationForm.controls['PROSPECT_CONTACT']['controls'][1].get('PHONE_LINE_TYPE').setErrors({ 'Invalid': true });
      this.phoneLineType = true;
    break;
    case ('phoneLineTypeTwo Select'):
      this.customerApplicationForm.controls['PROSPECT_CONTACT']['controls'][3].get('PHONE_LINE_TYPE').setErrors({ 'Invalid': true });
      this.phoneLineTypeTwo = true;
    break;
    default:
        this.addressState = false;
        this.addressCounty = false;
        this.phoneLineType = false;
        this.phoneLineTypeTwo = false;
  }
}


  initializeExistingCustomer(){

    this.customerApplicationForm = new FormGroup({

      //All these belong to the CUSTOMER_INFO table
      NEW_CUSTOMER_NAME: new FormControl(null),
      CUST_NAME_CHANGE_FLAG: new FormControl('N'),
      SOURCE_NAME: new FormControl('COD2CREDIT'),
      APPLICANT_NAME: new FormControl(null, [Validators.required,Validators.pattern(REGEX.newDBA)]),
      APPLICANT_COMMENTS: new FormControl(null),
      DBA_NAME: new FormControl(null, [Validators.pattern(REGEX.newDBA)]),
      BUSINESS_TYPE: new FormControl(null),
      STATE_ORG_ID: new FormControl(null, [Validators.required, Validators.pattern(REGEX.NUMBERS)]),
      JGZZ_FISCAL_CODE: new FormControl(null, [Validators.required, Validators.pattern(REGEX.NUMBERS)]),
      DNB_NUMBER: new FormControl(null, [Validators.pattern(REGEX.DNB_NUM)]),
      YRS_IN_BUSINESS: new FormControl(null, [Validators.pattern(REGEX.NUMBERS)]),
      PO_REQUIRED: new FormControl('N'),
      EST_ANNUAL_PUR_VOL: new FormControl(null, [Validators.pattern(REGEX.USD)]),
      CREDIT_LIMIT_REQUESTED: new FormControl(null, [Validators.required,Validators.pattern(REGEX.USD)]),
      CUSTOMER_CREDIT_AUTHORIZED: new FormControl('N'),
      CUSTOMER_REQUESTED_CREDIT: new FormControl('Y'),
      PST_NUM: new FormControl(null),
      TIRE_STEWARDSHIP: new FormControl(null),
      PREMISIS: new FormControl(null),
      RENTAL_PAYMENT: new FormControl(null),
      OWNER_FILED_BANKRUPT: new FormControl(null),
      BANKRUPT_REASON: new FormControl(null),
      TRUSTEE_NAME: new FormControl(null),
      ACCT_REQUESTED: new FormControl(null),
      BSNS_WITH_NTD: new FormControl(null),
      PRVS_BSNS_ACCT_NUM: new FormControl(null),
      TC_DATE: new FormControl(null),
      EMAIL_CORRESPONDENCE: new FormControl(null),
      ATD_CONTACT_PERSON: new FormControl(null),
      ATD_EMP_NUM: new FormControl(null),
      PROCESS_STATUS: new FormControl('PENDING'),
      PREV_ADDRR_LESS_THAN_3YR: new FormControl(null),
      TERMS_CONDITIONS_ACCEPT: new FormControl(null),
      // myRecaptcha : new FormControl(null, [Validators.required]),
      IS_CUST_TAX_EXEMPT: new FormControl('N'),
      STAGE_CUSTOMER_NUM: new FormControl(null),
      LIVE_CUSTOMER_NUM: new FormControl(null, [Validators.pattern(REGEX.NUMBERS)]),
      OWNER_FIRST_NAME: new FormControl(null, [Validators.required, Validators.pattern(REGEX.FIRST_NAME_LAST_NAME)]),
      OWNER_LAST_NAME: new FormControl(null, [Validators.required, Validators.pattern(REGEX.FIRST_NAME_LAST_NAME)]),
      TYPE_OF_BUSINESS: new FormControl(null),
      DATE_BUSINESS_OPENED: new FormControl(null, [Validators.pattern(REGEX.DATE)]),
      MYSQL_ORG_ID: new FormControl(this.mySQLOrgId, Validators.required),
      PROSPECT_CONTACT: new FormArray([
        this.initializeCustomerContact('BUSINESS', 'PHONE', 'APPLICANT'),
        this.initializeCustomerContact('BUSINESS', 'PHONE', 'OWNER'),
        this.initializeCustomerContact('BUSINESS', 'EMAIL', 'OWNER'),
        this.initializeCustomerContact('BUSINESS', 'PHONE', 'AP_CONTACT'),
        this.initializeCustomerContact('BUSINESS', 'EMAIL', 'AP_CONTACT'),]),
      PROSPECT_REFERENCE: new FormArray([
        this.initializeCustomerRef('AP_CONTACT'),
       

      ]),
      PROSPECT_ADDRESS: new FormArray([this.initializeCustomerAddress('SHIP_TO'),
      ]),
    });
     this.phonetypes = ['Mobile', 'Telephone'];
  }

    /**
   * Build Customer Contact Form Object
   */
  initializeCustomerContact = (CONTACT_POINT_PURPOSE: string, CONTACT_POINT_TYPE: string, CONTACT_TYPE: string) => {
    return new FormGroup({
      CONTACT_POINT_PURPOSE: new FormControl(CONTACT_POINT_PURPOSE),
      CONTACT_POINT_TYPE: new FormControl(CONTACT_POINT_TYPE),
      CONTACT_TYPE: new FormControl(CONTACT_TYPE),
      PRIMARY_FLAG: new FormControl(null),
      PRIMARY_BY_PURPOSE: new FormControl(null),
      PHONE_LINE_TYPE: new FormControl(null),
      PHONE_COUNTRY_CODE: new FormControl(null),
      PHONE_AREA_CODE: new FormControl(null, [Validators.pattern(REGEX.PHONE_NUMBER_AREA_CODE)]),
      PHONE_NUMBER: new FormControl(null, [Validators.pattern(REGEX.PHONE_NUMBER)]),
      PHONE_EXTENSION: new FormControl(null),
      WEB_TYPE: new FormControl(null),
      URL: new FormControl(null),
      EMAIL_FORMAT: new FormControl(CONTACT_POINT_TYPE === 'EMAIL' ? 'EMAILHTML' : null),
      EMAIL_ADDRESS: new FormControl(null, [Validators.pattern(REGEX.EMAIL_ADDRESS)]),
      MYSQL_ORG_ID: new FormControl(this.mySQLOrgId, Validators.required)
    });
  };


  /**
   * Build Customer Ref Form Object
   */
  initializeCustomerRef = (refType: string) => {
    return new FormGroup({
      REF_TYPE: new FormControl(refType),
      REF_NAME: new FormControl(null, [Validators.pattern(REGEX.FIRST_NAME_LAST_NAME)]),
      BANK_TRANSIT_NUM: new FormControl(null),
      BANK_ACCT_NUM: new FormControl(null),
      REF_ADDR1: new FormControl(null),
      REF_ADDR2: new FormControl(null),
      REF_CITY: new FormControl(null),
      REF_COUNTY: new FormControl(null),
      REF_STATE: new FormControl(null),
      REF_POSTAL_CODE: new FormControl(null),
      REF_POSTAL_PLUS4_CODE: new FormControl(null),
      CONTACT_PERSON: new FormControl(null),
      BANK_FAX_NUM: new FormControl(null),
      BANK_PH_NUM: new FormControl(null),
      PS_TR_COMP_NAME: new FormControl(null),
      PS_TR_FAX: new FormControl(null),
      PS_TR_PHONE: new FormControl(null),
      POSITION_NAME: new FormControl(null),
      REF_PHONE_NUM: new FormControl(null),
      REF_EMAIL: new FormControl(null),
      MYSQL_ORG_ID: new FormControl(this.mySQLOrgId, Validators.required)
    });
  };


  /**
   * Build Customer Address Form Object
   */
  initializeCustomerAddress = (addressType: string, required?: boolean) => {
    return new FormGroup({
      ADDRESS_TYPE: new FormControl(addressType),
      ADDRESS_LINE1: new FormControl(null, [Validators.pattern(REGEX.ADDRESS_BETA)]),
      ADDRESS_LINE2: new FormControl(null, [Validators.pattern(REGEX.ADDRESS_BETA)]),
      CITY: new FormControl(null, [Validators.pattern(REGEX.ADDRESS_BETA)]),
      COUNTY: new FormControl(null),
      COUNTY_FIPS: new FormControl(null),
      STATE: new FormControl(null),
      STATE_FIPS: new FormControl(null),
      POSTAL_CODE: new FormControl(null, [Validators.pattern(REGEX.ZIP_CODE)]),
      POSTAL_PLUS4_CODE: new FormControl(null),
      COUNTRY: new FormControl(this.currentCountry, [Validators.pattern(REGEX.ADDRESS_BETA)]),
      BILL_ADR_SAME_SHIP_ADR: new FormControl('Y'),
      NAME: new FormControl(null),
      POSITION: new FormControl(null),
      MYSQL_ORG_ID: new FormControl(this.mySQLOrgId, Validators.required)
    });
  };

    /**
   * Interlink FIPS Codes
   * @param index Index of Form Group Array
   * @param formArray Form Array
   * @param formControlName Source Form Control Name
   * @param assignToName Dest Form Control Name
   */
  public interlinkFIPS(index: number, formArray: string, formControlName: string, assignToName) {
    this.customerApplicationForm.controls[formArray]['controls'][index].controls[assignToName].value =
      this.customerApplicationForm.controls[formArray]['controls'][index].controls[formControlName].value.split('@')[1];
    this.customerApplicationForm.controls[formArray]['controls'][index].controls[formControlName].value =
      this.customerApplicationForm.controls[formArray]['controls'][index].controls[formControlName].value.split('@')[0];
  }


  /**
   * Initialize Counties Look Up
   * @param country Country aka Division
   */
  private initializeStates = (country: string) => {
    this.lookupService.lookup('STATES', 'TRUE', country, undefined, undefined)
      .subscribe(res => {
        this.states = res;
      });
  };


  /**
   * Initialize Countries Look Up
   */
  public initializeCounties = (state: string, forType: string) => {
    this.lookupService.lookup('COUNTIES', 'TRUE', undefined, state, undefined)
      .subscribe(res => {

        switch (forType) {
          case 'applicant':
            this.countiesApplicant = res;
            break;
          case 'refOne':
            this.countiesRefOne = res;
            break;
          case 'refTwo':
            this.countiesRefTwo = res;
            break;
        }

      });
  };


  /**
   * Initialize Business Types Look Up
   */
  private initializeBusinessStructures = (orgId) => {
    // Defaulting to US aka 82
    this.lookupService.lookup('BUSINESS_TYPES', undefined, undefined, undefined, orgId)
      .subscribe(res => {
        this.businessStructures = res;
      });
  };

  /**
   * Enable or Disable Form Fields
   * @param condition enable/disable
   */
  private toggleForm = (condition: string) => {
    Object.keys(this.customerApplicationForm.controls).forEach(
      (controlName) => {
        this.customerApplicationForm.controls[controlName][condition]();
      });
  };


  /**
   * Page Scroll
   * @param el HTMLElement
   * @description Used in Fixed Side Menu
   */
  scroll(el: HTMLElement) {
    el.scrollIntoView({behavior: 'smooth'});
  }

  
  /**
   * On Alert Close
   */
  onAlertClose() {
    this.showError = false;
    this.toggleForm('enable');
  }

    /**
   * Construct File Upload Object
   * @param body
   * @param base64Obj
   * @param docName
   * @param applicationId
   * @param prefix
   * @param file
   */
  public constructFileUploadObj(body, base64Obj, docName, applicationId, prefix, file) {

    const result = body;
    result.DOC_NAME = file.customName;
    result.LINK_TO_DOC = null;
    result.MYSQL_ORG_ID = this.mySQLOrgId;
    result.DOC_TYPE = prefix;
    result.APPLICATION_ID = applicationId;
    result.EXISTING_CUSTOMER ='Y';

    return JSON.stringify(result);
  }

  /**
   * Rename File
   * @param file File Object
   * @param applicationId Application Id
   * @param prefix Prefix
   */
  public static renameFile(file, applicationId, prefix) {
 
    const resultFile = file;
    let resultFileType = resultFile.type.split('/')[1];
    const doc = 'msword';
    const docx = 'vnd.openxmlformats-officedocument.wordprocessingml.document';
    const xls = 'vnd.ms-excel';
    const xlsx = 'vnd.openxmlformats-officedocument.spreadsheetml.sheet';

    if(resultFileType === doc){
      resultFileType = 'doc';
    } else if(resultFileType === docx){
      resultFileType = 'docx';
    } else if(resultFileType === xls){
      resultFileType = 'xls';
    } else if(resultFileType === xlsx){
      resultFileType = 'xlsx';
    }

    resultFile.customName = `${prefix}_${applicationId}.${resultFileType}`;

    return resultFile;

  }
 

/**
 * CAPTCHA VALIDATIONS 
 */

  handleReset(): void {
    this.captchaSuccess = false;
    this.captchaResponse = undefined;
    this.captchaIsExpired = false;
  }

  handleSuccess(captchaResponse: string): void {
    this.captchaSuccess = true;
    this.captchaResponse = captchaResponse;
    this.captchaIsExpired = false;
    this.validateCaptcha();
  }

  handleLoad(): void {
    this.captchaIsLoaded = true;
    this.captchaIsExpired = false;
  }

  handleExpire(): void {
    this.captchaSuccess = false;
    this.captchaIsExpired = true;
  }

  validateCaptcha(){

    let payload: any;
    payload = {

      captachResponse: this.captchaResponse,

    };
    this.customerService.validateCaptcha(payload).subscribe(res => {

      if(res['success']){

        console.log('Verified');
      }else{

        this.captchaElem.reloadCaptcha();
        this.captchaElem.resetCaptcha();

      }

    });
  }



  openModal(){

    const invalids = [];
    const contactArray = [];

    if(this.customerApplicationForm.invalid){

      this.handleError('Please fill out the mandatory fields.To proceed,Please close this message');
      //PROSPECT INFO
      const prospectInfoControls = this.customerApplicationForm.controls;
      for (const name in prospectInfoControls) {
          if (prospectInfoControls[name].invalid) {
               invalids.push(name);
               prospectInfoControls[name].markAsTouched();
          }
      }

      //PROSPECT ADDRESS
      let prospectAddressControls: any  = [];
      prospectAddressControls = this.customerApplicationForm.controls['PROSPECT_ADDRESS']['controls'];
      prospectAddressControls.forEach((addressControl,index) => {
        for(const name in addressControl['controls']) {
          if(addressControl['controls'][name].invalid){
            addressControl['controls'][name].markAsTouched();
            this.validateDropdown(name, index);
          }
        }
      });

      // PROSPECT CONTACT

      let prospectContactControls: any  = [];
      prospectContactControls = this.customerApplicationForm.controls['PROSPECT_CONTACT']['controls'];
      prospectContactControls.forEach((contactControl,index) => {
      for(const name in contactControl['controls']) {
        if(contactControl['controls'][name].invalid){
            contactControl['controls'][name].markAsTouched();
            this.validateDropdown(name, index);
          }
        }
      });

      //  PROSPECT REFERENCE
    let prospectReferenceControls: any  = [];
      prospectReferenceControls = this.customerApplicationForm.controls['PROSPECT_REFERENCE']['controls'];
      prospectReferenceControls.forEach((referenceControl,index) => {
        for(const name in referenceControl['controls']) {
          if(referenceControl['controls'][name].invalid){
            referenceControl['controls'][name].markAsTouched();
            this.validateDropdown(name, index);
          }
        }
      });

      } else{
        this.submitApplication();
      }
}

validateDropdown(name:any, index:any){
  if(name=== "PHONE_LINE_TYPE" && index === 1){
    this.phoneLineType = true;
  } else if(name=== "PHONE_LINE_TYPE" && index === 3){
    this.phoneLineTypeTwo = true;
  } else if(name=== "STATE" && index === 0){
    this.addressState = true;
  } else if (name=== "COUNTY" && index === 0){
    this.addressCounty = true;
  } 
 }

  /**
   * Submit Customer Application
   */
  public submitApplication() {

    this.toggleForm('disable');
    this.validateBtnState = ClrLoadingState.LOADING;

      this.customerService.submitFormExisting(this.customerApplicationForm.value).subscribe(res => {

        const uploadObservables = [];
        const applicationId = res['APPLICATION_ID'];

          this.validateBtnState = ClrLoadingState.SUCCESS;
          this.messagesService.sendConfMessage(applicationId);
          this.router.navigate([`/confirmation/${applicationId}`]);
          }, err => {

        this.handleError("Error: Sorry, we are unable to process the application.");

      });


    // }

  }

  /**
   * Handle Error
   * @param err Error
   */
  private handleError(errMessage?) {
    this.errorMessage = errMessage;
    this.showError = true;
    console.log(`Error Submitting the form : ${errMessage}`);
    const top = document.getElementById('errorMessage');
    this.scroll(top);
    this.validateBtnState = ClrLoadingState.DEFAULT;
  }
 

  initializeValidators() {

    this.customerApplicationForm.controls['DNB_NUMBER'].setValidators([Validators.required]);

    //APPLICANT VALIDATORS
    this.customerApplicationForm.controls['PROSPECT_CONTACT']['controls'][0].get('PHONE_AREA_CODE').setValidators([Validators.required,
    Validators.pattern(REGEX.PHONE_NUMBER_AREA_CODE)]);
    this.customerApplicationForm.controls['PROSPECT_CONTACT']['controls'][0].get('PHONE_NUMBER').setValidators([Validators.required,
    Validators.pattern(REGEX.PHONE_NUMBER)]);
    this.customerApplicationForm.controls['PROSPECT_ADDRESS']['controls'][0].get('CITY').setValidators([Validators.required,
    Validators.pattern(REGEX.ADDRESS_BETA)]);
    this.customerApplicationForm.controls['PROSPECT_ADDRESS']['controls'][0].get('ADDRESS_LINE1').setValidators([Validators.required,
    Validators.pattern(REGEX.ADDRESS_BETA)]);
    this.customerApplicationForm.controls['PROSPECT_ADDRESS']['controls'][0].get('STATE').setValidators([Validators.required]);
    this.customerApplicationForm.controls['PROSPECT_ADDRESS']['controls'][0].get('COUNTY').setValidators([Validators.required]);
    this.customerApplicationForm.controls['PROSPECT_ADDRESS']['controls'][0].get('POSTAL_CODE').setValidators([Validators.required,
       Validators.pattern(REGEX.ZIP_CODE)]);

    //OWNER VALIDATORS
    this.customerApplicationForm.controls['PROSPECT_CONTACT']['controls'][1].get('PHONE_AREA_CODE').setValidators([Validators.required,
    Validators.pattern(REGEX.PHONE_NUMBER_AREA_CODE)]);
    this.customerApplicationForm.controls['PROSPECT_CONTACT']['controls'][1].get('PHONE_NUMBER').setValidators([Validators.required,
    Validators.pattern(REGEX.PHONE_NUMBER)]);
    this.customerApplicationForm.controls['PROSPECT_CONTACT']['controls'][1].get('PHONE_LINE_TYPE').setValidators([Validators.required]);

    //AP_CONTACT VALIDATORS

    this.customerApplicationForm.controls['PROSPECT_REFERENCE']['controls'][0].get('REF_NAME').setValidators([Validators.required,
    Validators.pattern(REGEX.FIRST_NAME_LAST_NAME)]);
    this.customerApplicationForm.controls['PROSPECT_CONTACT']['controls'][3].get('PHONE_AREA_CODE').setValidators([Validators.required,
    Validators.pattern(REGEX.PHONE_NUMBER_AREA_CODE)]);
    this.customerApplicationForm.controls['PROSPECT_CONTACT']['controls'][3].get('PHONE_NUMBER').setValidators([Validators.required,
    Validators.pattern(REGEX.PHONE_NUMBER)]);
    this.customerApplicationForm.controls['PROSPECT_CONTACT']['controls'][4].get('EMAIL_ADDRESS').setValidators([Validators.required,
    Validators.pattern(REGEX.EMAIL_ADDRESS)]);
    this.customerApplicationForm.controls['PROSPECT_CONTACT']['controls'][3].get('PHONE_LINE_TYPE').setValidators([Validators.required]);

    //Adding country code
    this.customerApplicationForm.controls['PROSPECT_CONTACT']['controls'][0].controls['PHONE_COUNTRY_CODE'].setValue(this.phoneCountryCode);
    this.customerApplicationForm.controls['PROSPECT_CONTACT']['controls'][1].controls['PHONE_COUNTRY_CODE'].setValue(this.phoneCountryCode);
    this.customerApplicationForm.controls['PROSPECT_CONTACT']['controls'][3].controls['PHONE_COUNTRY_CODE'].setValue(this.phoneCountryCode);

  }

  resetNewBusinessName(value: string){

    if(value === 'N'){

      this.customerApplicationForm.controls['NEW_CUSTOMER_NAME'].clearValidators();
      this.customerApplicationForm.controls['NEW_CUSTOMER_NAME'].reset();
      
    }else{

      this.customerApplicationForm.controls['NEW_CUSTOMER_NAME'].setValidators([Validators.required, Validators.pattern(REGEX.newDBA)]);

    }

  }
}
